import dayjs from 'dayjs';

export const ALRAM_MODE: string = 'alram';
export const DAY_MODE: string = 'day';

/**
 *  選択モード
 */
export const SelectMode = {
  /* アラーム日選択モード*/
  ALRAM_MODE: 1,
  /* 日時選択モード*/
  DAY_MODE: 2,
} as const;
export type SelectMode = typeof SelectMode[keyof typeof SelectMode];

export type SelectDataType = {
  devIndex: string; //選択機器番号
  alramDate: string; //選択アラーム発生日
  selectDate: string; //選択日時
  selectMode: SelectMode; //alram or day
};

/**
 *EMCトレンドデータ
 */
export type EMCTrendGraphData = {
  ColData: Date; //収集時間
  itemNameNo: number//ラインアイテムNo
  PercentValue: number//パーセント値
  RawValue: number//値
};

/**
 *EMCトレンド情報
 */
export type EMCAlarmInfoModel = {
  AlarmKind: string; //異常種別を取得します。
  ItemNo: string; //項目 No. を
  ItemName: string; //項目名を取得します。
  UNIT: string; //単位を取得または設定します。
  UnitNo: string; //ユニット No. を取得します。
  AreaNo: string; //局番を取得します。
  EmcDataType: string; //データタイプを取得します。
  IsDisplay: boolean; //表示するかを取得または設定します。
  ChartLineColor: string; //グラフ線色を取得または設定します
  OutputValue: string; //出力を取得または設定します。
  ChartSeriesIndex: string; //出力を取得または設定します。
  TrendGraphDatas: EMCTrendGraphData[]; //グラフデータを設定します
};

//EMC設定データ取得
export const GetEMCTrendDatas = (selectData : SelectDataType) : Promise<EMCAlarmInfoModel[]> => {
   let params = {
      devIndex: "",
      from: "",
     to: "",
      selectMode : ""
  };

  if (selectData.selectMode === SelectMode.ALRAM_MODE) {
    params.to  = ConvertDateToStringByDate(dayjs(selectData.alramDate).add(1, "d").toDate());
    params.from = ConvertDateToStringByDate(dayjs(params.to).subtract(3, "d").toDate());
    params.selectMode = SelectMode.ALRAM_MODE.toString();
  }
  else {
    params.to  = ConvertDateToStringByDate(dayjs(selectData.selectDate).toDate());
    params.from = ConvertDateToStringByDate(dayjs(params.to).subtract(3, "d").toDate());
    params.selectMode = SelectMode.DAY_MODE.toString();
  }
  params.devIndex = selectData.devIndex;

  console.debug(["GetEMCTrendDatas - params ", params,selectData]);
  const query_params = new URLSearchParams(params);
  return new Promise((resolve, reject) => {
    //fetch("api/EMCTrend/EMCTrendDatas?devIndex=1&from=2022-02-01 00:00:00&to=2022-02-01 23:59:59")
    fetch("api/EMCTrend/EMCTrendDatas?" + query_params )
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          reject(message);
        }
        else {
          res.json()
            .then((result: EMCAlarmInfoModel[]) => {
              console.debug(["GetEMCTrendDatas - result",result]);
              if (result != null) {
                if (result.length !== 0) {
                  result.forEach((r) => r.ItemName = r.ItemName === null ? "(予備)" : r.ItemName);
                  resolve(result);
                }
                else {
                  reject('Invalidate response');
                }
              }
              else {
                reject('Invalidate response');
              }
            })
            .catch((error) => {
            console.error(error);
            reject(error);
          })
        }
      })
  });
};

/**
 * 画面で使用する日時の表示フォーマット
 * @returns
 */
export const ConvertDateToStringByString = (target: string): string => {
  const isInvalidDate = (date: Date) => Number.isNaN(date.getTime());//Invalid Date 判定
  if (target !== null && target !== "") {
    if (isInvalidDate(dayjs(target).toDate())){
      return "";
    }
    else {
      return dayjs(target).format('YYYY/MM/DD HH:mm:ss');
    }
  }
  else {
    return "";
  }
};

/**
 * 画面で使用する日時の表示フォーマット
 * @returns
 */
export const ConvertDateToStringByDate = (target: Date): string => {
  if (target !== null) {
    return dayjs(target).format('YYYY/MM/DD HH:mm:ss');
  }
  else {
    return "";
  }
};


/**
 * 画面で使用する日時の表示フォーマット
 * ０～29分の場合０分00秒、３０～59分の場合30分00秒を返す
 * @returns
 */
export const ConvertDateToStringByMarume = (target: Date): string => {
  if (target !== null) {
    let m = Number(dayjs(target).format('mm'));
    if (m < 30) {
      return dayjs(target).format('YYYY/MM/DD HH:00:00');
    }
    else {
      return dayjs(target).format('YYYY/MM/DD HH:30:00');
    }
  }
  else {
    return "";
  }
};



/**
 *　グラフの縦線を引く場所を取得する
 *　選択したアラーム時間がトレンドデータに存在するかを確認
 *　存在した場合はそのまま返す
 *　存在しなかった場合は、一番近い時間を返す
 * @param data EMCトレンドデータ
 * @param selectAlramDate　選択アラーム時間
 * @returns
 */
export const GetAlaramBasePoint = (data: EMCAlarmInfoModel, selectAlramDate: string): string => {
  if (data.TrendGraphDatas.length === 0) {
    return "";
  }
  if (validate(selectAlramDate,"YYYY/MM/DD HH:30:00") ) {
    return "";
  }

  const sData = dayjs(selectAlramDate);
  const gList = data.TrendGraphDatas;

  let tempSa: number = 0;
  let tempData: Date = sData.toDate();
  gList.forEach((item,index) => {
    const sa = dayjs(item.ColData).diff(sData);
    if (index === 0) {
      tempSa = Math.abs(sa);
      tempData = item.ColData;
    }
    else {
      if (tempSa > Math.abs(sa)) {
        tempSa = Math.abs(sa);
        tempData = item.ColData;
      }
    }
  });

  console.debug(["getAlaramBasePoint",sData,tempSa,tempData]);
  return dayjs(tempData).format('YYYY-MM-DDTHH:mm:ss');
  };


/**
 * 存在する日時かどうかを確認
 * validate('2020/02/31', 'YYYY/MM/DD') // false
 * @param date
 * @param format
 * @returns
 */
const validate = (date:string, format:string) => {
  return dayjs(date, format).format(format) === date;
};
